var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./modal.vue?vue&type=custom&index=0&blockType=div&class=fixed%20bottom-0%20inset-x-0%20px-4%20pb-4%20sm%3Ainset-0%20sm%3Aflex%20sm%3Aitems-center%20sm%3Ajustify-center"
if (typeof block0 === 'function') block0(component)

export default component.exports